import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={28}
    height={28}
    viewBox={'0 0 28 28'}
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#fff'}
      d="M.01 13.325 13.554 27.17C16.963 23.72 23.77 16.848 27.17 13.397l-1.685-1.744c-3.068 3.112-7.15 7.22-10.729 10.841l.06-22.49-2.4-.006-.06 22.49L1.706 11.59 0 13.325h.01Z"
    />
  </Svg>
);
export default SvgComponent;
